import { Component, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PaymentService } from '../payment.service';
import { Settlement, SettlementItems } from '../payment.type';

export interface SettlementItemsDialogData {
  settlement: Settlement;
}

/**
 * What a settlement pays for: the transfer runs and manual contracts linked to
 * it. If an admin later marked one of them unpaid it is detached, so the items
 * can add up to less than the recorded amount — that is shown, not hidden.
 */
@Component({
  selector: 'app-settlement-items-dialog',
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatProgressSpinnerModule],
  templateUrl: './settlement-items-dialog.html',
  styleUrl: './settlement-items-dialog.scss',
})
export class SettlementItemsDialog implements OnInit {
  private paymentService = inject(PaymentService);
  readonly data = inject<SettlementItemsDialogData>(MAT_DIALOG_DATA);

  items: SettlementItems | null = null;
  loading = true;
  error: string | null = null;

  ngOnInit(): void {
    this.paymentService.getSettlementItems(this.data.settlement.id).subscribe({
      next: items => { this.items = items; this.loading = false; },
      error: err => { this.error = err?.error?.error ?? 'Failed to load what this settlement pays'; this.loading = false; },
    });
  }

  get itemsTotal(): number {
    if (!this.items) return 0;
    return this.items.runs.reduce((a, r) => a + r.payable_amount, 0)
      + this.items.contracts.reduce((a, c) => a + c.payable_amount, 0);
  }

  get coinsTotal(): number {
    if (!this.items) return 0;
    return this.items.runs.reduce((a, r) => a + r.coins_transferred, 0)
      + this.items.contracts.reduce((a, c) => a + c.received_coins, 0);
  }
}
